module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also by Anita Waller")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Kat and Mouse series")])])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Murder Undeniable (Book 1)")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Murder Unexpected (Book 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Murder Unearthed (Book 3)")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Murder Untimely (Book 4)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-125"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-snowflake-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Psychological thrillers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Beautiful")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("34 Days")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Strategy")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Captor")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Game Players")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Malignant")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Liars")]), _vm._v(" (co-written with Patricia Dixon)")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Gamble")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Epitaph")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-125"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-snowflake-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Supernatural")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Winterscroft")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c403801","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-anita-waller.vue
// module id = 72
// module chunks = 0